// import { useFormik } from 'formik';

// import { useTranslation } from 'react-i18next';
// import { useAppDispatch } from '@store/hooks';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import { Form } from 'react-bootstrap';
// import { PaymentsCreateAccount } from '@store/Finance/AP/ApPayments/ApPaymentsSlice';
// import { useState } from 'react';
// import { Card, CardBody } from '@components/card/card';

// interface Props {
//   selectedApPayments: any[];

//   onClose: () => void;
// }

// const AddCreateAccountApPayments = ({ selectedApPayments, onClose }: Props) => {
//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();
//   const [responseData, setResponseData] = useState<any[]>([]);

//   const formik = useFormik({
//     initialValues: {},

//     // validationSchema: CreateAccountSchema(t),
//     onSubmit: values => {
//       const ids = selectedApPayments.map(m => m.id);

//       const body = {
//         transections: ids
//       };

//       dispatch(PaymentsCreateAccount(body))
//         .unwrap()
//         .then((res: any) => {
//           if (res.succeeded) {
//             setResponseData(res.data || []);

//             // CustomAlert({
//             //   action: 'info',
//             //   msg: t('لقد تمت العملية بنجاح، يُرجى الاطلاع على تفاصيل النجاح في الجدول التالي')
//             //   // msg: t('PostSuccessMessage')
//             // });
//           } else {
//             CustomAlert({
//               action: 'Error',
//               msg: res.message
//             });
//           }
//         })
//         .catch((error: any) => {
//           console.log(error);
//           CustomAlert({ action: 'Error', msg: error });
//         })
//         .finally(() => {
//           formik.setSubmitting(false);
//         });
//     }
//   });

//   return (
//     <>
//       <div className='table-responsive  mb-2'>
//         <table className='table  table-sm table-bordered'>
//           <thead className='bg-theme bg-opacity-10 '>
//             <tr>
//               <th className='pt-2 pb-2'>{t('نوع السند')}</th>
//               <th className='pt-2 pb-2'>{t('رقم السند')}</th>
//               <th className='pt-2 pb-2'>{t('Supplier')}</th>
//               <th className='pt-2 pb-2'>{t('Date')}</th>
//               <th className='pt-2 pb-2'>{t('Amount')}</th>
//             </tr>
//           </thead>

//           <tbody>
//             {selectedApPayments?.map((item, index) => (
//               <tr key={item.id}>
//                 <td className='align-middle'>
//                   {i18n.language === 'en' ? item.paymentTypeName : item.paymentTypeName2}
//                 </td>
//                 <td className='align-middle'>{item.code}</td>
//                 <td className='align-middle'>{i18n.language === 'en' ? item.peopleName : item.peopleName2}</td>
//                 <td className='align-middle'>{item.paymentDate?.toString()?.split('T')[0]} </td>
//                 <td className='align-middle'>{item.amount}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {responseData.length > 0 && (
//         <div className='mt-2'>
//           {/* Card للرسالة */}
//           <Card className='card border-success mb-2 shadow-sm'>
//             <CardBody className='card-body d-flex align-items-center text-success'>
//               <i className='fas fa-check-circle text-success me-2 fs-4'></i>
//               <span className='fs-5 fw-semibold'>{t('تمت العملية بنجـاح ( راجع التفاصيل .. )')}</span>
//             </CardBody>
//           </Card>

//           <div className='table-responsive'>
//             <table className='table table-striped table-hover align-middle mb-0'>
//               <thead className='table-light'>
//                 <tr>
//                   <th>{t('code')}</th>
//                   <th>{t('type')}</th>
//                   <th>{t('activeFlag')}</th>
//                   <th>{t('validOnDate')}</th>
//                   <th>{t('رسالة الخطأ او النجاح')}</th>
//                   <th>{t('الحالة')}</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {responseData.map((item, index) => (
//                   <tr key={index} style={{ verticalAlign: 'middle' }}>
//                     <td className='fw-medium'>{item.code}</td>
//                     <td>{i18n.language === 'en' ? item.type : item.type2}</td>
//                     <td>
//                       {item.activeFlag ? (
//                         <span className='badge bg-success'>{t('Yes')}</span>
//                       ) : (
//                         <span className='badge bg-danger'>{t('No')}</span>
//                       )}
//                     </td>
//                     <td>{item.validOnDate?.split('T')[0] || '-'}</td>
//                     <td>
//                       <span className='text-danger'>{item.errorMessage || '-'}</span>
//                     </td>
//                     <td>
//                       {item.succeeded ? (
//                         <span className='text-success'>
//                           <i className='fas fa-check-circle me-1'></i> {t('Success')}
//                         </span>
//                       ) : (
//                         <span className='text-danger'>
//                           <i className='fas fa-times-circle me-1'></i> {t('Failed')}
//                         </span>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//         </div>
//       )}

//       <Form onSubmit={formik.handleSubmit}>
//         <div className='row mt-2'>
//           <div className='col-6'>
//             <button
//               type='submit'
//               className='btn btn-lg btn-theme  w-100 rounded-0'
//               disabled={formik.isSubmitting || responseData.length > 0}
//             >
//               {formik.isSubmitting ? (
//                 <div className='spinner-border spinner-border-sm me-2'></div>
//               ) : (
//                 <i className='fas fa-lg fa-fw me-2 fa-check-circle'></i>
//               )}
//               {t('Post')}
//             </button>
//           </div>
//           <div className='col-6'>
//             <button type='button' className='btn btn-lg  btn-default   w-100 rounded-0' onClick={onClose}>
//               <i className='fas fa-times-circle fa-fw me-1'></i> {t('Cancel')}
//             </button>
//           </div>
//         </div>
//       </Form>
//     </>
//   );
// };

// export default AddCreateAccountApPayments;

import { useFormik } from 'formik';
import { useMemo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PaymentsCreateAccount } from '@store/Finance/AP/ApPayments/ApPaymentsSlice';
import { useAppDispatch } from '@store/hooks';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { Card, CardBody, CardHeader, CardFooter } from '@components/card/card';
import confirmAction from '@components/Shared/Alert/confirmAction';
import NeatixModal from '@components/Modal/NeatixModal';
import JournalsByReference from '@pages/Finance/Journals/JournalsByReference/JournalsByReference';
import { paymentTypeEnum } from '../paymentTypeEnum';

interface Props {
  selectedApPayments: any[];
  onClose: () => void;
}

const AddCreateAccountApPayments = ({ selectedApPayments, onClose }: Props) => {
  const { t, i18n } = useTranslation();
  const [responseData, setResponseData] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState<'summary' | 'details'>('summary');
  const [showResults, setShowResults] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAllDetails, setShowAllDetails] = useState(false);

  // ✅ Journal Modal State
  const [showJournalModal, setShowJournalModal] = useState(false);
  const [journalRefId, setJournalRefId] = useState<string | null>(null);

  const dispatch = useAppDispatch();

  // ✅ Auto-scroll to results when showResults changes
  useEffect(() => {
    if (showResults) {
      setTimeout(() => {
        const resultsSection = document.getElementById('processing-results');
        if (resultsSection) {
          resultsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, [showResults]);

  // ✅ دالة تحاول استخراج الـ referenceId من نتيجة الـ API أو تعمل fallback على id من selectedApPayments
  const resolveReferenceId = (resultItem: any) => {
    const direct = resultItem?.referenceId ?? resultItem?.paymentId ?? resultItem?.refId ?? resultItem?.id;

    if (direct) return String(direct);

    // fallback: إذا code = voucherNum نجيب id من selectedApPayments
    const matched = selectedApPayments?.find(x => String(x.code) === String(resultItem?.code));
    return matched?.id ? String(matched.id) : null;
  };

  const openJournal = (refId: string | null) => {
    if (!refId) return;
    setJournalRefId(refId);
    setShowJournalModal(true);
  };

  const formik = useFormik({
    initialValues: {},
    onSubmit: async () => {
      const ids = selectedApPayments?.map(m => m.id);
      const body = { transections: ids };

      const confirm = await confirmAction(t('confirmPostMessage'));
      if (!confirm) {
        return;
      }

      setIsSubmitting(true);
      setShowResults(false);
      setResponseData([]);

      dispatch(PaymentsCreateAccount(body))
        .unwrap()
        .then(res => {
          if (res.succeeded) {
            const data = res.data || [];
            setResponseData(data);
            setShowResults(true);

            const successCount = data.filter((item: any) => item.succeeded).length;
            const errorCount = data.filter((item: any) => !item.succeeded).length;
            const totalCount = data.length;

            if (errorCount === 0) {
              CustomAlert({
                action: 'Add',
                msg: t('PostSuccessMessage'),
                Timer: 5000
              });
            } else if (successCount === 0) {
              CustomAlert({
                action: 'Error',
                msg: t('AllOperationsFailed'),
                Timer: 10000
              });
            } else {
              CustomAlert({
                action: 'Error',
                msg: `${successCount}/${totalCount} ${t('operationsSucceeded')}`,
                Timer: 8000
              });
            }
          } else {
            CustomAlert({
              action: 'Add',
              msg: res.message || t('PostErrorMessage')
            });
          }
        })
        .catch((error: any) => {
          console.error('Post error:', error);
          CustomAlert({
            action: 'Error',
            msg: error.message || t('PostErrorMessage')
          });
        })
        .finally(() => {
          formik.setSubmitting(false);
          setIsSubmitting(false);
        });
    }
  });

  // ✅ إحصائيات
  const successCount = responseData.filter(item => item.succeeded).length;
  const errorCount = responseData.filter(item => !item.succeeded).length;
  const totalCount = responseData.length;

  // ✅ Map للنتائج عشان نعرض حالة كل سند في جدول المحدد
  const resultByVoucherNum = useMemo(() => {
    const map = new Map<string, any>();
    responseData.forEach(r => {
      if (r?.code != null) map.set(String(r.code), r);
    });
    return map;
  }, [responseData]);

  const getStatusBadge = (payment: any) => {
    if (!showResults) {
      return (
        <span className='badge bg-warning bg-opacity-20 text-warning border border-warning border-opacity-50'>
          <i className='fas fa-clock me-1'></i>
          {t('Pending')}
        </span>
      );
    }

    const r = resultByVoucherNum.get(String(payment.code));
    if (!r) {
      return (
        <span className='badge bg-secondary bg-opacity-20 text-secondary'>
          <i className='fas fa-question-circle me-1'></i>
          {t('Unknown')}
        </span>
      );
    }

    return r.succeeded ? (
      <span className='badge bg-success bg-opacity-20 text-success border border-success border-opacity-50'>
        <i className='fas fa-check-circle me-1'></i>
        {t('Success')}
      </span>
    ) : (
      <span className='badge bg-danger bg-opacity-20 text-danger border border-danger border-opacity-50'>
        <i className='fas fa-exclamation-circle me-1'></i>
        {t('Failed')}
      </span>
    );
  };

  // دالة تحويل نوع الدفع إلى Badge مع أيقونة
  // const getPaymentTypeDisplay = (type: string, name: string) => {
  //   switch (type) {
  //     case '52ea7dc3-92b7-406d-9f79-f12e0fb8fdb2': // قياسي
  //       return (
  //         <span className='badge bg-primary'>
  //           <i className='fas fa-receipt me-1'></i>
  //           {name}
  //         </span>
  //       );
  //     case 'e232d787-c1d1-4d97-be39-ff52f9010683': // دفعة مقدمة
  //       return (
  //         <span className='badge bg-info text-dark'>
  //           <i className='fas fa-hand-holding-usd me-1'></i>
  //           {name}
  //         </span>
  //       );
  //     case 'b600351c-8d3c-43df-83c4-9120a79c74aa': // استرداد
  //       return (
  //         <span className='badge bg-warning text-dark'>
  //           <i className='fas fa-undo-alt me-1'></i>
  //           {name}
  //         </span>
  //       );
  //     default:
  //       return (
  //         <span className='badge bg-secondary'>
  //           <i className='fas fa-question-circle me-1'></i>
  //           {name}
  //         </span>
  //       );
  //   }
  // };

  const getPaymentTypeDisplay = (type: string, name: string) => {
    switch (type) {
      case paymentTypeEnum.Standard:
        return (
          <span className={`badge bg-primary `} title={name}>
            <i className='fas fa-file-invoice-dollar me-1'></i>
            قياسي
          </span>
        );
      case paymentTypeEnum.PrePayment:
        return (
          <span className={`badge bg-success `} title={name}>
            <i className='fas fa-hand-holding-usd me-1'></i>
            مقدمة
          </span>
        );
      case paymentTypeEnum.Refund:
        return (
          <span className={`badge bg-danger `} title={name}>
            <i className='fas fa-rotate-left me-1'></i>
            استرداد
          </span>
        );
      case paymentTypeEnum.ApplyPrePayment:
        return (
          <span className={`badge bg-info text-dark `} title={name}>
            <i className='fas fa-link me-1'></i>
            تطبيق مقدمة
          </span>
        );
      case paymentTypeEnum.ApplyDebitMemo:
        return (
          <span className={`badge bg-warning text-dark `} title='تطبيق إشعار مدين'>
            <i className='fas fa-file-invoice me-1'></i>
            تطبيق مدين
          </span>
        );
      default:
        return (
          <span className={`badge bg-secondary `} title={name}>
            <i className='fas fa-question-circle me-1'></i>
            {name}
          </span>
        );
    }
  };

  const formatAmount = (amount: number) => {
    return new Intl.NumberFormat(i18n.language, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  const displayedDetails = showAllDetails ? responseData : responseData.slice(0, 5);

  return (
    <>
      <div className='p-0'>
        {/* رأس الصفحة */}
        <div className='d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom'>
          <div>
            <h4 className='m-0 text-theme fw-bold'>
              <i className='fas fa-file-invoice-dollar me-2'></i>
              {t('ترحيل سندات المدفوعات')}
            </h4>
          </div>
          <button
            type='button'
            className='btn btn-outline-secondary btn-sm'
            onClick={onClose}
            disabled={formik.isSubmitting || isSubmitting}
          >
            <i className='fas fa-times me-1'></i>
            {t('Close')}
          </button>
        </div>

        {/* بطاقة السندات المحددة */}
        <div className='mb-4'>
          <Card className='bg-primary bg-opacity-10 border-primary border-0 shadow-sm'>
            <CardBody className='d-flex align-items-center p-3'>
              <i className='fas fa-file-invoice-dollar fa-2x text-primary me-3'></i>
              <div className='flex-grow-1'>
                <h4 className='text-primary mb-0'>{selectedApPayments?.length || 0} سند دفع</h4>
                {/* <p className='text-muted mb-0 small'>محددة للترحيل</p> */}
              </div>
         
            </CardBody>
          </Card>
        </div>

        {/* السندات المحددة */}
        <Card className='mb-4 border-0 shadow-sm'>
          <CardHeader className='d-flex justify-content-between align-items-center bg-transparent border-0'>
            <h5 className='mb-0'>
              <i className='fas fa-list-check me-2 text-theme'></i>
              السندات المحددة
              <span className='badge bg-primary ms-2'>{selectedApPayments?.length || 0}</span>
            </h5>
            <div>
              <span className='badge bg-theme me-2'>إجمالي المحدد: {selectedApPayments?.length || 0}</span>
            </div>
          </CardHeader>

          <CardBody className='p-0'>
            <div className='table-responsive' style={{ maxHeight: '300px' }}>
              <table className='table table-hover mb-0'>
                <thead
                  className='table-active fw-bold'
                  style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 101,
                    backdropFilter: 'blur(30px)'
                  }}
                >
                  <tr>
                    <th className='text-center small'>رقم السند</th>
                    <th className='text-center small'>المورد</th>
                    <th className='text-center small'>التاريخ</th>
                    <th className='text-center small'>نوع السند</th>
                    <th className='text-center small'>المبلغ</th>
                    <th className='text-center small'>الحالة</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedApPayments?.map((item: any) => {
                    const TypeName = i18n.language === 'en' ? item.paymentTypeName : item.paymentTypeName2;

                    return (
                      <tr key={item.id}>
                        <td className='text-center align-middle'>
                          <strong className='text-theme'>{item.code}</strong>
                        </td>
                        <td className='align-middle'>
                          <div className='d-flex flex-column'>
                            <strong>{i18n.language === 'en' ? item.peopleName : item.peopleName2}</strong>
                            {item.peopleCode && (
                              <small className='text-muted'>
                                {t('Code')}: {item.peopleCode}
                              </small>
                            )}
                          </div>
                        </td>
                        <td className='text-center align-middle'>
                          <strong>{item.paymentDate?.toString()?.split('T')[0]}</strong>
                        </td>
                        <td className='align-middle'>{getPaymentTypeDisplay(item.paymentType, TypeName)}</td>
                        <td className='text-center align-middle'>
                          <span className='fw-bold text-theme'>{formatAmount(item.amount)}</span>
                        </td>
                        <td className='text-center align-middle'>{getStatusBadge(item)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              {(!selectedApPayments || selectedApPayments.length === 0) && (
                <tr>
                  <td colSpan={6} className='text-center py-4 text-muted'>
                    <i className='fa fa-inbox fa-2x mb-2'></i>
                    <br />
                    {t('NoTransactionsSelected')}
                  </td>
                </tr>
              )}
            </div>
          </CardBody>

          <CardFooter className='d-flex justify-content-between align-items-center bg-transparent'>
            <div className='text-muted small'>
              عرض {selectedApPayments?.length || 0} من {selectedApPayments?.length || 0} سند
            </div>
            {/* <div className='text-theme fw-bold'>
              <i className='fas fa-info-circle me-1'></i>
              جاهزة للمعالجة
            </div> */}
          </CardFooter>
        </Card>

        {/* نتائج المعالجة */}
        {showResults && responseData.length > 0 && (
          <div id='processing-results' className='mt-4'>
            <Card className='border-0 shadow-sm'>
              <CardHeader className='bg-transparent border-0'>
                <div className='d-flex justify-content-between align-items-center'>
                  <div>
                    <h5 className='m-0 text-theme'>
                      <i className='fas fa-chart-bar me-2'></i>
                      {t('ProcessingResults')}
                    </h5>
                  </div>

                  <div className='btn-group btn-group-sm' role='group'>
                    <button
                      type='button'
                      className={`btn ${activeTab === 'summary' ? 'btn-theme' : 'btn-outline-theme'}`}
                      onClick={() => setActiveTab('summary')}
                    >
                      <i className='fas fa-chart-pie me-1'></i>
                      {t('Summary')}
                    </button>
                    <button
                      type='button'
                      className={`btn ${activeTab === 'details' ? 'btn-theme' : 'btn-outline-theme'}`}
                      onClick={() => setActiveTab('details')}
                    >
                      <i className='fas fa-list me-1'></i>
                      {t('Details')}
                    </button>
                  </div>
                </div>
              </CardHeader>

              <CardBody>
                {activeTab === 'summary' ? (
                  <>
                    {/* بطاقات إحصائيات النتائج */}
                    <div className='row mb-4'>
                      {/* إجمالي المعالجة */}
                      <div className='col-md-4'>
                        <Card className='bg-primary bg-opacity-10 border-primary border-0 shadow-sm'>
                          <CardBody className='text-center py-4'>
                            <i className='fas fa-cogs fa-2x text-primary mb-3'></i>
                            <h3 className='text-primary mb-1'>{totalCount}</h3>
                            <p className='text-muted mb-0'>إجمالي المعالجة</p>
                          </CardBody>
                        </Card>
                      </div>

                      {/* ناجحة */}
                      <div className='col-md-4'>
                        <Card className='bg-success bg-opacity-10 border-success border-0 shadow-sm'>
                          <CardBody className='text-center py-4'>
                            <i className='fas fa-check-circle fa-2x text-success mb-3'></i>
                            <h3 className='text-success mb-1'>{successCount}</h3>
                            <p className='text-muted mb-0'>عمليات ناجحة</p>
                          </CardBody>
                        </Card>
                      </div>

                      {/* فاشلة */}
                      <div className='col-md-4'>
                        <Card className='bg-danger bg-opacity-10 border-danger border-0 shadow-sm'>
                          <CardBody className='text-center py-4'>
                            <i className='fas fa-times-circle fa-2x text-danger mb-3'></i>
                            <h3 className='text-danger mb-1'>{errorCount}</h3>
                            <p className='text-muted mb-0'>عمليات فاشلة</p>
                          </CardBody>
                        </Card>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className='table-responsive' style={{ maxHeight: '400px' }}>
                      <table className='table table-hover mb-0'>
                        <thead className='table-active fw-bold'>
                          <tr>
                            <th className='text-center small'>رقم السند</th>
                            <th className='text-center small'>النوع</th>
                            <th className='text-center small'>الحالة</th>
                            <th className='text-center small'>التفاصيل</th>
                            <th className='text-center small'>الإجراءات</th>
                          </tr>
                        </thead>
                        <tbody>
                          {displayedDetails.map((item: any, index: number) => {
                            const refId = resolveReferenceId(item);
                            return (
                              <tr key={index} className={item.succeeded ? 'table-success' : 'table-danger'}>
                                <td className='text-center align-middle'>
                                  <strong>{item.code}</strong>
                                </td>
                                <td className='text-center align-middle'>
                                  <span className='badge bg-info'>
                                    {i18n.language === 'en' ? item.type : item.type2}
                                  </span>
                                </td>
                                <td className='text-center align-middle'>
                                  {item.succeeded ? (
                                    <span className='badge bg-success'>
                                      <i className='fas fa-check-circle me-1'></i>
                                      {t('Success')}
                                    </span>
                                  ) : (
                                    <span className='badge bg-danger'>
                                      <i className='fas fa-exclamation-circle me-1'></i>
                                      {t('Failed')}
                                    </span>
                                  )}
                                </td>
                                <td className='align-middle'>
                                  <div className={`small ${item.succeeded ? 'text-success' : 'text-danger'}`}>
                                    <i
                                      className={`fas fa-${item.succeeded ? 'check-circle' : 'exclamation-triangle'} me-1`}
                                    ></i>
                                    {item.succeeded ? t('Successful') : item.errorMessage || t('OperationFailed')}
                                  </div>
                                </td>
                                <td className='text-center align-middle'>
                                  {item.succeeded && refId ? (
                                    <button
                                      type='button'
                                      className='btn btn-sm btn-outline-primary'
                                      onClick={() => openJournal(refId)}
                                      title={t('ViewJournalEntry')}
                                    >
                                      <i className='fas fa-eye me-1'></i>
                                      {t('عرض القيد')}
                                    </button>
                                  ) : (
                                    <span className='text-muted small'>-</span>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>

                      {responseData.length > 5 && (
                        <div className='text-center py-3 border-top'>
                          <button
                            type='button'
                            className='btn btn-link text-decoration-none'
                            onClick={() => setShowAllDetails(!showAllDetails)}
                          >
                            <i className={`fas fa-chevron-${showAllDetails ? 'up' : 'down'} me-1`}></i>
                            {showAllDetails ? t('ShowLess') : t('ShowAllResults', { count: responseData.length })}
                          </button>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </CardBody>

              {activeTab === 'details' && (
                <CardFooter className='d-flex justify-content-between align-items-center bg-transparent'>
                  <div className='text-muted small'>
                    عرض {displayedDetails.length} من {responseData.length} نتيجة
                  </div>
                  <div className='text-theme fw-bold'>
                    ناجحة: {successCount} | فاشلة: {errorCount}
                  </div>
                </CardFooter>
              )}
            </Card>
          </div>
        )}

        {/* أزرار الإجراء */}
        <form onSubmit={formik.handleSubmit} className='mt-4'>
          <div className='row g-3'>
            <div className='col-md-6'>
              <button
                type='submit'
                className='btn btn-theme w-100 py-3 d-flex align-items-center justify-content-center'
                disabled={formik.isSubmitting || isSubmitting || selectedApPayments?.length === 0}
              >
                {formik.isSubmitting || isSubmitting ? (
                  <>
                    <div className='spinner-border spinner-border-sm me-2'></div>
                    {t('Processing')}...
                  </>
                ) : (
                  <>
                    <i className='fas fa-paper-plane me-2'></i>
                    <div className='d-flex flex-column align-items-start'>
                      <span className='fw-bold'>{t('Post')}</span>
                    </div>
                  </>
                )}
              </button>
            </div>
            <div className='col-md-6'>
              <button
                type='button'
                className='btn btn-outline-secondary w-100 py-3 d-flex align-items-center justify-content-center'
                onClick={onClose}
                disabled={formik.isSubmitting || isSubmitting}
              >
                <i className='fas fa-times me-2'></i>
                <span className='fw-bold'>{t('Cancel')}</span>
              </button>
            </div>
          </div>
        </form>
      </div>

      {/* ✅ Modal عرض القيد */}
      <NeatixModal show={showJournalModal} setShow={setShowJournalModal} size='xl' showHeader={false}>
        <div className='p-3 bg-theme bg-opacity-10'>
          <div className='d-flex align-items-center justify-content-between mb-3'>
            <div>
              <h5 className='m-0 text-theme'>
                <i className='fas fa-book me-2'></i>
                {t('عرض القيد')}
              </h5>
             </div>
            <button
              type='button'
              className='btn btn-outline-secondary btn-sm'
              onClick={() => setShowJournalModal(false)}
            >
              <i className='fas fa-times me-1'></i>
              {t('Close')}
            </button>
          </div>

          {journalRefId && <JournalsByReference referenceId={journalRefId} />}
        </div>
      </NeatixModal>
    </>
  );
};

export default AddCreateAccountApPayments;
